import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Ekyc from "./Pages/Ekyc";
// import CompleteProfile from "./Pages/CompleteProfile";
// import ESign from "./Pages/Esign";
// import Payment from "./Pages/Payment";
import NotFoundModel from "./Components/NotFoundModel";
// import Receipt from "./Pages/Receipt";
import MakePayment from "./Pages/PaymentEasebuzz";
import PaymentSuccess from "./Pages/PaymentSuccess";
import PaymentFailure from "./Pages/PaymentFailure";
// import PaymentPayu from "./Pages/PaymentPayu";

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />

      <Routes>
        {/* <Route path="/:token" element={<Ekyc />} /> */}
        <Route path="/:token" element={<MakePayment />} />
        <Route path="/:token/:dueId" element={<MakePayment />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailure />} />
        {/* <Route path="/complete-profile" element={<CompleteProfile />} /> */}
        {/* <Route path="/rent-agreement" element={<ESign />} /> */}
        {/* <Route path="/payment" element={<Payment />} /> */}
        {/* <Route path="/payment" element={<PaymentPayu />} /> */}
        {/* <Route path="/receipt" element={<Receipt />} /> */}
        <Route path="*" element={<NotFoundModel />} />
      </Routes>
    </>
  );
}

export default App;
